import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { supabase } from '@/lib/supabase'

export default function AuthCallbackPage() {
  const navigate = useNavigate()
  const location = useLocation()

  const rawFrom = (location.state as { from?: string })?.from
  const from = rawFrom?.startsWith('/') ? rawFrom : '/profile'

  useEffect(() => {
    let redirected = false

    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession()
      if (session?.user && !redirected) {
        redirected = true
        navigate(from, { replace: true })
      }
    }

    checkSession()

    const { data } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user && !redirected) {
        redirected = true
        navigate(from, { replace: true })
      }
    })

    const timeout = setTimeout(async () => {
      const { data: { session } } = await supabase.auth.getSession()
      if (session?.user && !redirected) {
        redirected = true
        navigate(from, { replace: true })
      }
    }, 5000)

    return () => {
      clearTimeout(timeout)
      data?.subscription?.unsubscribe()
    }
  }, [navigate, location, from])

  return (
    <div className="container flex items-center justify-center min-h-[calc(100vh-3.5rem)]">
      <p className="text-muted-foreground">Completing sign in...</p>
    </div>
  )
}